import { useParams } from 'react-router-dom'

import EditMedicalLeaveUpdate from 'modules/timeoff/components/EditMedicalLeaveUpdate'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const EditMedicalLeaveUpdatePage = () => {
  const { leave_update_id: leaveUpdateId } = useParams()
  const onClose = useOnClose()

  if (!leaveUpdateId) {
    return null
  }

  return <EditMedicalLeaveUpdate leaveUpdateId={leaveUpdateId} onClose={onClose} />
}

export default EditMedicalLeaveUpdatePage
